import { render, staticRenderFns } from "./ItemCustomFields.vue?vue&type=template&id=c50cebb4&scoped=true"
import script from "./ItemCustomFields.vue?vue&type=script&lang=js"
export * from "./ItemCustomFields.vue?vue&type=script&lang=js"
import style0 from "./ItemCustomFields.vue?vue&type=style&index=0&id=c50cebb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50cebb4",
  null
  
)

export default component.exports